import { useTranslate } from 'hooks/useTranslate';

import {
  getEmployeeAddress,
  getEmployeeEmail,
  getEmployeeFullName,
  getEmployeeNationality,
  getEmployeePhoneNumber,
} from 'utils/employees';

function EmployeePersonal({ employee, incorporationDate }) {
  const { t } = useTranslate();

  const fullName = getEmployeeFullName(employee);
  const address = getEmployeeAddress(employee);
  const phoneNumber = getEmployeePhoneNumber(employee);
  const email = getEmployeeEmail(employee);
  const nationality = getEmployeeNationality(employee);

  const dataList = [
    { label: t('FactorialEmployeeId'), value: employee?.externalId },
    { label: t('FullName'), value: fullName },
    { label: t('NifNiPassport'), value: employee?.cif },
    { label: t('Telephone'), value: phoneNumber },
    { label: t('Address'), value: address },
    { label: t('Email'), value: email },
    { label: t('IncoporationDate'), value: incorporationDate },
    { label: t('Nationality'), value: nationality },
  ];

  return (
    <div className="card-inner">
      <div className="nk-block-head">
        <h4 className="title">{t('PersonalInformation')}</h4>
        <p>{t('BasicPersonalInformationEmployee')}</p>
        <div className="nk-block-head nk-block-head-line" />

        {dataList.map(({ label, value }) => (
          <div className="profile-ud wider d-flex flex-column flex-md-row">
            <span className="profile-ud-label w-200px">{label}</span>
            <span className="profile-ud-value text-left">{value || '-'}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmployeePersonal;
